import axiosConfig from './axiosConfig';
import { exportData } from './export';

// Get aggregated report
export const getAggregatedReport = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('reports/aggregate', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Export aggregated report as XLSX
export const exportAggregatedReportXLSX = async (queryParams = {}) => {
    return exportData('reports/aggregate/export/xlsx', 'dashboardReports', queryParams);
};

// Get vendor performance report
export const getVendorPerformanceReport = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('reports/vendor-performance', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};